import React, { useCallback, useEffect, useState } from 'react';

import { FiShoppingCart, FiDollarSign, FiCheck } from 'react-icons/fi';
import { IoMdPaper } from 'react-icons/io';
import { IconBaseProps } from 'react-icons/lib';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { routesEndpoints } from '../../routes/endpoint';
import { StoreState } from '../../store/createStore';
import { orderCheckoutClear, sendRequestNew, setMethodPaymentSelected } from '../../store/modules/checkout/actions';
import {
  btnNextCheckout,
  findShippingValue,
  viewCheckout,
  setMessageToast,
  addressesSelectedRequest,
  openShowModal,
  viewModal,
  clearShippingOption,
} from '../../store/modules/parameter/actions';

import {
  Root,
  Container,
  ContainerSectionHeader,
  ContainerSteps,
  StepItem,
  ContainerSectionBody,
  ContainerSectionFooter,
  ContainerButtons,
  Button,
} from './styles';
import ViewCheckout from './ViewCheckout';
import ViewCompletion from './ViewCompletion';
import ViewConference from './ViewConference';
import ViewPayment from './ViewPayment';

import { useCheckoutInfo } from '../../hooks/useCheckoutInfo';
import { useTranslation } from '../../hooks/useTranslation';
import { useCheckoutFunction } from '../../hooks/useCheckoutFunctions';
import PaymentConfirmCVV from '../../components/PaymentConfirmCVV';
import AlertModal from '../../components/AlertModal';
import { config } from '../../config';

interface StepProps {
  id: number;
  active: boolean;
  bshow: boolean;
  name: string;
  title: string;
  icon: IconBaseProps;
}

interface IdxProps {
  iViewCheckout: number;
  iViewPayment: number;
  iViewConference: number;
  iViewCompletion: number;
}

const idxSelect = {
  iViewCheckout: 0,
  iViewPayment: 1,
  iViewConference: 2,
  iViewCompletion: 3,
} as IdxProps;

interface AddressSelectedProps {
  type: 'addressUser' | 'addressStore' | 'addressLocker';
  id: number;
}

interface MethodSelectedProps {
  type: number;
  id: number;
}

const NewCheckout: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [idxSel, selIdxSel] = useState(0); // default: 0 - 3
  const [bSendOrder, setbSendOrder] = useState(false);
  const [stepsList, setStepsList] = useState<StepProps[]>([]);
  const [stepsListWrk, setStepsListWrk] = useState<StepProps[]>([]);
  const {
    store,
    address,
    locker,
    method,
    payOnDelivery,
    selectedShippingOption,
  } = useSelector(
    (state: StoreState) => state.parameter,
  );
  const { checkout, shipping, loading, methodPaymentSelected, orderCheckout } = useSelector((state: StoreState) => state.checkout);
  const {
    user: { data },
    isSignedIn,
  } = useSelector((state: StoreState) => state.auth);
  const {
    selShipping,
    addressSelected,
    onSetaddressSelect,
    onSetSelShipping,
    onsetMethodSelect,
  } = useCheckoutInfo();
  const { onTranslation: t } = useTranslation();
  const { handleUpdateCheckout } = useCheckoutFunction();

  const handlerAlertCheckout = useCallback(() => {
    dispatch(viewModal(AlertModal, { width: '50%', height: '100%', buttonClose: true }, true));
  }, [dispatch]);

  useEffect(() => {
    handlerAlertCheckout();
  }, [handlerAlertCheckout, isSignedIn]);

  useEffect(() => {
    if (idxSel === idxSelect.iViewCheckout) {
      onSetaddressSelect({} as AddressSelectedProps);
      dispatch(clearShippingOption())
      dispatch(setMethodPaymentSelected({
            cards: [],
            cashOnDelivery: [],
            others: []
      }));
    }
  }, [onSetaddressSelect, idxSel, dispatch]);

  useEffect(() => {
    if (data.seller === 1 && !selShipping) {
      checkout.customer?.data.customer.address?.map(address => {
        if (address.selected) {
          dispatch(addressesSelectedRequest(address, false));
          onSetaddressSelect({ id: address.id, type: 'addressUser' });
          if (address.postcode) {
            dispatch(findShippingValue('shipment', address, onSetaddressSelect));
          }
        }
      });
    }
    onsetMethodSelect({} as MethodSelectedProps);
    // selIdxSel(0);
    dispatch(viewCheckout(true));
  }, [
    dispatch,
    onSetaddressSelect,
    onSetSelShipping,
    onsetMethodSelect,
    checkout.customer,
    checkout.id,
    data.seller,
    selShipping,
  ]);

  useEffect(() => {
    if (isSignedIn === false) {
      onSetaddressSelect({} as AddressSelectedProps);
      onsetMethodSelect({} as MethodSelectedProps);
      selIdxSel(0);
    }
  }, [isSignedIn, onSetaddressSelect, history, onsetMethodSelect]);

  useEffect(() => {
    if (orderCheckout && orderCheckout.order.order_id
      && orderCheckout.order.order_id > 0
      && checkout.id > 0
      && orderCheckout.order.cart_id !== checkout.id) {
      dispatch(orderCheckoutClear());
      selIdxSel(0);
    }
  }, [orderCheckout, checkout.id, dispatch, selIdxSel]);

  useEffect(() => {
    setStepsList([
      {
        id: 1,
        active: true, // default: true
        bshow: false,
        name: 'checkout',
        title: t('main.new_checkout.card'),
        icon: <FiShoppingCart size={19} />,
      },
      {
        id: 2,
        active: false, // default: false
        bshow: data.seller === 1 ? true : false,
        name: 'payment',
        title: t('main.new_checkout.payment'),
        icon: <FiDollarSign size={19} />,
      },
      {
        id: 3,
        active: false, // default: false
        bshow: false,
        name: 'conference',
        title: t('main.new_checkout.conference'),
        icon: <IoMdPaper size={19} />,
      },
      {
        id: 4,
        active: false, // default: false
        bshow: false,
        name: 'completion',
        title: t('main.new_checkout.completion'),
        icon: <FiCheck size={19} />,
      },
    ]);
    //konsole.log('useEffect...')
  }, [data.seller, t]);

  useEffect(() => {
    if (idxSel === idxSelect.iViewCheckout && !loading) handleUpdateCheckout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idxSel]);

  const handleadStepBack = useCallback(() => {
    if (idxSel === 0) {
      history.push(routesEndpoints.HOME);
      dispatch(viewCheckout(false));
    }

    if (data.seller === 1 && idxSel === 2) selIdxSel(idxSel => idxSel - 2);
    else {
      selIdxSel(idxSel => idxSel - 1);
    }
  }, [idxSel, dispatch, history, data.seller]);

  const handleadStepNext = useCallback(async () => {
    // if (btnCheckoutNext) return
    if (idxSel > 2 || loading ) {
      return;
    }

    if (data.seller === 1 && !checkout.customer) {
      dispatch(
        setMessageToast({
          type: 'error', message: t('main.messages_toast.find_customer_fist')
        }),
      );
      //dispatch(setMessageToastClear());
      return;
    }

    if (idxSel === idxSelect.iViewCheckout && (Number(checkout.sub_total) - Number(checkout.discount) === 0)) {
      dispatch(
        setMessageToast({
          type: 'error', message: t('main.messages_toast.checkout_total_zero')
        }),
      );
      return;
    }

    if (idxSel === idxSelect.iViewCheckout && Object.values(checkout.items).filter(item => item.is_available === undefined || item.is_available === 1).length < 1) {
      dispatch(
        setMessageToast({
          type: 'error', message: t('main.messages_toast.without_product_available')
        }),
      );
      //dispatch(setMessageToastClear());
      return;
    }

    if (idxSel === idxSelect.iViewCheckout && !addressSelected.id) {
      dispatch(
        setMessageToast({
          type: 'error', message: t('main.messages_toast.select_address')
        }),
      );
      //dispatch(setMessageToastClear());
      return;
    } else if (
      idxSel === idxSelect.iViewCheckout
      && !selectedShippingOption
      && addressSelected.type !== "addressStore"
    ) {
      dispatch(
        setMessageToast({
          type: 'error', message: t('main.messages_toast.selected_shipping')
        }),
      );
      //dispatch(setMessageToastClear());
      return;
    } else if (idxSel === idxSelect.iViewCheckout
      && selectedShippingOption
      && selectedShippingOption.carrier === "beedeliveryschedule"
      && !selectedShippingOption.chosen_shipping_date
    ) {
      dispatch(
        setMessageToast({
          type: 'error', message: t('main.messages_toast.selected_shipping_date')
        }),
      );
      //dispatch(setMessageToastClear());
      return;
    } else if (
      idxSel === idxSelect.iViewPayment && ((!config.isNewLayoutChosePayment && method && !method.id)
      || (config.isNewLayoutChosePayment && (
        methodPaymentSelected.cards.length === 0 &&
        methodPaymentSelected.others.length === 0 &&
        methodPaymentSelected.cashOnDelivery.length === 0
      )))) {
      dispatch(
        setMessageToast({
          type: 'error', message: t('main.messages_toast.select_method')
        }),
      );
      //dispatch(setMessageToastClear());
      return;
    }
    if (data.seller === 1 && idxSel === 0) selIdxSel(idxSel => idxSel + 2);
    else if (idxSel === 2) {
      if (payOnDelivery || (
        methodPaymentSelected.cashOnDelivery.length > 0
        || methodPaymentSelected.others.length > 0 )
      ) {
        if (data.email) {
          dispatch(
            sendRequestNew({
              email: data.email,
              checkout: {
                ...checkout,
                shipping
              },
              store: store,
              address: address,
              locker: locker,
              method: method,
              sellerId: data.customer_id,
              shippingMethod: selectedShippingOption?.carrier,
              shippingDate:  selectedShippingOption?.chosen_shipping_date,
              payOnDelivery,
              windowsConfig: {
                width: window.screen.width,
                height: window.screen.height,
                colorDepth: window.screen.colorDepth
              }
            }),
          );
        }
      }
      else {
        dispatch(openShowModal(true));
        dispatch(viewModal(PaymentConfirmCVV, { width: '750px', height: '70%' }));
      }
    } else selIdxSel(idxSel => idxSel + 1);

    dispatch(btnNextCheckout());
  }, [
    idxSel,
    dispatch,
    addressSelected,
    t,
    checkout,
    shipping,
    data,
    method,
    store,
    address,
    locker,
    payOnDelivery,
    selectedShippingOption,
    methodPaymentSelected,
    loading,
  ]);

  const sendRequestNewFunction = useCallback(() => {
    if (data.seller === 1 && checkout.customer?.data.customer) {
      dispatch(
        sendRequestNew(
          {
            email: checkout.customer?.data.customer.email,
            checkout: {
              ...checkout,
              shipping
            },
            store,
            address,
            locker,
            method,
            sellerId: data.customer_id,
            shippingMethod: selectedShippingOption?.carrier,
            shippingDate:  selectedShippingOption?.chosen_shipping_date,
            payOnDelivery,
            windowsConfig: {
              width: window.screen.width,
              height: window.screen.height,
              colorDepth: window.screen.colorDepth
            }
          }
        ),
      );
    } else if (data.email) {
      dispatch(
        sendRequestNew(
          {
            email: data.email,
            checkout: {
              ...checkout,
              shipping
            },
            store,
            address,
            locker,
            method,
            shippingMethod: selectedShippingOption?.carrier,
            shippingDate:  selectedShippingOption?.chosen_shipping_date,
            payOnDelivery,
            windowsConfig: {
              width: window.screen.width,
              height: window.screen.height,
              colorDepth: window.screen.colorDepth
            }
          }),
      );
    }

    setbSendOrder(true);
  }, [
    dispatch,
    data,
    checkout,
    shipping,
    store,
    address,
    locker,
    method,
    setbSendOrder,
    payOnDelivery,
    selectedShippingOption
  ]);

  useEffect(() => {
    //konsole.log("idxSel ...", idxSel)

    if (!stepsList) return;

    stepsList.filter((item, idx) => {
      if (idx <= idxSel) {
        return (item.active = true);
      } else {
        return (item.active = false);
      }
    });

    if (stepsList.length > 0) {
      setStepsListWrk(stepsList);
      //setStepsList([]);
    }
  }, [idxSel, sendRequestNewFunction, stepsList, bSendOrder]);

  // Depois olha isso kkkkk, com calma #23:45:48
  useEffect(() => {
    if (stepsListWrk.length > 0) {
      setStepsList(stepsListWrk);
      setStepsListWrk([]);
    }
  }, [stepsListWrk]);

  useEffect(() => {
    //konsole.log('data.verified: ', data.verified)
    if (data.verified === 0 && data.seller !== 1) {
      history.push(routesEndpoints.VERIFICATION_MAIL);
    }
  }, [data.verified, history, data.seller]);

  return (
    <Root>
      <Container>
        {checkout && orderCheckout.order.order_id ? (
          <>
            {orderCheckout.order.order_id > 0 ? (
              <>
                <ViewCompletion />
              </>
            ) : (
              <>
                <ContainerSectionHeader>
                  <h4>{t('main.new_checkout.not_product_card')}</h4>
                </ContainerSectionHeader>
              </>
            )}
          </>
        ) : (
          <>
            {!Object.keys(checkout.items).length && !loading ? (
              <>
                <ContainerSectionHeader>
                  <h4>{t('main.new_checkout.not_product_card')}</h4>
                </ContainerSectionHeader>
              </>
            ) : (
              <>
                <ContainerSectionHeader>
                  <h1>{ }</h1>
                  <ContainerSteps>
                    {stepsList &&
                      stepsList.map((item, idx) => {
                        return (
                          <StepItem
                            key={idx}
                            active={item.active}
                            bShow={item.bshow}
                          >
                            {idx > 0 && <div />}{' '}
                            <span>
                              {item.icon} {item.title}
                            </span>{' '}
                            {idx < 3 && <div />}
                          </StepItem>
                        );
                      })}
                  </ContainerSteps>
                </ContainerSectionHeader>

                <ContainerSectionBody>
                  {idxSel === idxSelect.iViewCheckout && <ViewCheckout />}
                  {idxSel === idxSelect.iViewPayment && <ViewPayment />}
                  {idxSel === idxSelect.iViewConference && <ViewConference />}
                  {idxSel === idxSelect.iViewCompletion && <ViewCompletion />}
                </ContainerSectionBody>

                {idxSel <= 2 && !loading && (
                  <>
                    <ContainerSectionFooter>
                      <ContainerButtons>
                        <Button
                          id="button-action-back-checkout"
                          onClick={handleadStepBack}
                          bgColor="#e22301"
                          fgColor="#FFFFFF"
                        >
                          {idxSel === 0 ? (
                            <span>{t('main.new_checkout.keep_buying')}</span>
                          ) : (
                            <span>{t('main.globals.back')}</span>
                          )}
                        </Button>
                        {/* <Button onClick={handleadStepNext} bgColor="#00b300" fgColor="#FFFFFF" disabled={idxSel === 1 && !method ? true : false}> */}
                        <Button
                          id="button-action-next-checkout"
                          onClick={handleadStepNext}
                          bgColor="#00b300"
                          fgColor="#FFFFFF"
                        >
                          {idxSel === 2 ? (
                            <span>{t('main.new_checkout.finish_payment')}</span>
                          ) : (
                            <span>{t('main.globals.continue')}</span>
                          )}
                        </Button>
                      </ContainerButtons>
                    </ContainerSectionFooter>
                  </>
                )}
              </>
            )}
          </>
        )}
      </Container>
    </Root>
  );
};

export default NewCheckout;
